import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Download from '~/components/Download';
import images from '~/constants/images';
import downloadFile from '~/utils/downloadFile';
import { useSelector } from 'react-redux';
import * as S from '../styles';
import GrassInfoColumn from '../components/GrassInfoColumn';
import GrassInfoRow from '../components/GrassInfoRow';
import { propTypes, defaultProps } from './propsValidation';

export default function GrassStatus({
  grassStatus,
  irrigationProgram,
  publicFiles,
}) {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const [pdfLoading, setPdfLoading] = useState(false);

  return (
    <S.GreenKeeperContainer>
      <S.GrassImage>
        <S.GrassImageColumn left>
          <div>
            <GrassInfoColumn
              icon="grass"
              data={
                grassStatus.grassCompounds ? grassStatus.grassCompounds : '-'
              }
              label={t('grassType')}
            />
            <GrassInfoColumn
              icon="hibryd"
              data={grassStatus.isHybridSystem ? t('yes') : t('no')}
              label={t('grasshybrid')}
            />
            <GrassInfoColumn
              icon="hibrydSystem"
              data={grassStatus.hybridSystem ? grassStatus.hybridSystem : '-'}
              label={t('hybridSystem')}
            />
          </div>
        </S.GrassImageColumn>
        <S.GrassImageColumn center>
          <img src={images.grass} alt="" />
        </S.GrassImageColumn>
        <S.GrassImageColumn right>
          <div>
            <GrassInfoColumn
              icon="height"
              data={grassStatus.grassHeight ? grassStatus.grassHeight : '-'}
              label={`${t('grassHeight')} (mm)`}
            />
            <GrassInfoColumn
              icon="program"
              data={irrigationProgram}
              label={t('grassProgram')}
            />
          </div>
        </S.GrassImageColumn>
      </S.GrassImage>
      <GrassInfoRow title={t('meteorology')}>
        <GrassInfoColumn
          icon="temperature"
          data={
            grassStatus.weatherForecastTemperature
              ? grassStatus.weatherForecastTemperature
              : '-'
          }
          label={`${t('temperature')} (ºC)`}
        />
        <GrassInfoColumn
          icon="humidity"
          data={
            grassStatus.weatherForecastHumidity
              ? grassStatus.weatherForecastHumidity
              : '-'
          }
          label={`${t('relativeHumidity')} (%)`}
        />
        <GrassInfoColumn
          icon="precipitations"
          data={
            grassStatus.weatherForecastRainfallType
              ? grassStatus.weatherForecastRainfallType
              : '-'
          }
          label={t('precipitations')}
        />
      </GrassInfoRow>
      <GrassInfoRow title={t('pitch')}>
        <GrassInfoColumn
          icon="dimensions"
          data={
            grassStatus.venueHeight && grassStatus.venueWidth
              ? `${grassStatus.venueHeight} x ${grassStatus.venueWidth}`
              : '-'
          }
          label={`${t('dimensions')} (m)`}
        />
        <GrassInfoColumn
          icon="temperature"
          data={
            grassStatus.grassTemperature ? grassStatus.grassTemperature : '-'
          }
          label={`${t('floorTemperarure')} (ºC)`}
        />
        <GrassInfoColumn
          icon="hardness"
          data={grassStatus.hardnessGround ? grassStatus.hardnessGround : '-'}
          label={`${t('floorHardness')} (G)`}
        />
      </GrassInfoRow>
      <Download
        onClick={() => {
          if (publicFiles.data.greenkeeper)
            downloadFile(publicFiles.data.greenkeeper.id, setPdfLoading);
        }}
        disabled={
          Object.keys(publicFiles.data).length === 0 ||
          !publicFiles.data.greenkeeper
        }
        text={t('downloadGrassDesignation')}
        loading={pdfLoading}
        competition={match?.competitionId}
      />
    </S.GreenKeeperContainer>
  );
}

GrassStatus.propTypes = propTypes;
GrassStatus.defaultProps = defaultProps;
